import { pushEventAndTrack, pushRecommendation } from './taggingSerializer'
import { randomString } from '../utils/index'

const createEventData = (eventName, eventAction, recommendation) => {
  const eventRef = randomString(5)
  return {
    attributes: {
      recommendations: recommendation
    },
    eventInfo: {
      eventName,
      eventAction,
      eventRef
    }
  }
}

const fireRecommendationBlockViewed = analyticsData => {
  // This function is called when recommendations are scrolled to
  const eventName = 'pdp_recommendationsViewed'
  const eventAction = 'Recommendations Viewed'
  const eventData = createEventData(eventName, eventAction, analyticsData)
  pushEventAndTrack(eventData, eventName, eventData.eventInfo.eventRef)
}

const fireRecommendationBlockLoaded = analyticsData => {
  // This function is called when the page is loaded
  const eventName = 'pdp_recommendationsLoaded'
  const eventAction = 'Recommendations Loaded'
  const eventData = createEventData(eventName, eventAction, analyticsData)
  pushEventAndTrack(eventData, eventName, eventData.eventInfo.eventRef)
  pushRecommendation(analyticsData)
}

const fireRecommendationAnalyticsNewPage = analyticsData => {
  // This function is called when you switch between pages
  // of recommendations using the carousel navigation controls
  const eventName = 'pdp_recommendationsNewPageViewed'
  const eventAction = 'Recommendations New Page Viewed'
  const eventData = createEventData(eventName, eventAction, analyticsData)
  pushEventAndTrack(eventData, eventName, eventData.eventInfo.eventRef)
  pushRecommendation(analyticsData)
}

const isNotABot = () => {
  return /bot|googlebot|crawler|spider|robot|crawling|Google-InspectionTool/i.test(navigator?.userAgent) === false
}

const generateUrlParameters = params => {
  // ?rec=PDP[1112222]:bottomSlider:P1:OHAT:alternative:6530639:2234567890asdfghjkla
  const { fromProduct, toProduct, toCategory, sectionPlacement, innerPlacement, sectionTitle, strategy } = params
  const rndStr = randomString()
  const fromParameter = fromProduct === 'Error404' ? '-404' : `[${fromProduct}]`
  const query = isNotABot()
    ? `?rec=PDP${fromParameter}:${sectionPlacement}:${innerPlacement}:${sectionTitle}:${strategy}:${toProduct ||
        toCategory}:${rndStr}`
    : ''
  return query
}

const removeAllSpecialCharacters = string => string.replace(/[^a-zA-Z0-9 ]/g, '')

const getAcronym = string =>
  removeAllSpecialCharacters(string)
    .match(/\b(\w)/g)
    .join('')
    .toUpperCase()

const getAnalyticsData = ({ products, headline, displayedList, source, mvts, pageIndex }) => {
  const fullList = products.map(product => product.id || product.ProductSKU)
  return {
    fullList,
    displayedList,
    title: headline,
    strategy: source,
    placement: source,
    mvts,
    sectionTitle: getAcronym(headline),
    innerPlacement: `P${pageIndex}`,
    pageCategory: 'PDP',
    sectionPlacement: 'bottomSlider'
  }
}

export {
  fireRecommendationBlockLoaded,
  fireRecommendationBlockViewed,
  fireRecommendationAnalyticsNewPage,
  generateUrlParameters,
  getAnalyticsData
}
